// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.opening-amount-input {
  width: 100% !important;
  border-radius: 7px !important;
  padding: 8px;
  border: 1px solid lightgray !important;
  margin-top: 0.5rem !important;
}

.dark .opening-amount-input {
  background-color: #2b2f42;
  color: white;
}

.opening-amount-input:focus {
  outline: none;
}

.login-as-manager {
  display: flex;
  justify-content: flex-start;
}
.opening-amount-button {
  width: 100% !important;
}

.sessionPageLabel {
  color: var(--surface-g4);
  font-size: 1rem;
  font-weight: 400;
}

.opening-amount-input-v2 {
  width: 100%;
  border: 1px solid var(--surface-g2);
  border-radius: 8px;
  padding: 12px 16px;
}

.openingPageButtonContainer {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.newOpeningPageContainer {
  width: 100%;
  padding: 0px 64px;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/Opening/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".opening-amount-input {\n  width: 100% !important;\n  border-radius: 7px !important;\n  padding: 8px;\n  border: 1px solid lightgray !important;\n  margin-top: 0.5rem !important;\n}\n\n.dark .opening-amount-input {\n  background-color: #2b2f42;\n  color: white;\n}\n\n.opening-amount-input:focus {\n  outline: none;\n}\n\n.login-as-manager {\n  display: flex;\n  justify-content: flex-start;\n}\n.opening-amount-button {\n  width: 100% !important;\n}\n\n.sessionPageLabel {\n  color: var(--surface-g4);\n  font-size: 1rem;\n  font-weight: 400;\n}\n\n.opening-amount-input-v2 {\n  width: 100%;\n  border: 1px solid var(--surface-g2);\n  border-radius: 8px;\n  padding: 12px 16px;\n}\n\n.openingPageButtonContainer {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.newOpeningPageContainer {\n  width: 100%;\n  padding: 0px 64px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
